module.exports = __webpack_public_path__ + "9335d93e69eb8de764dbe60103e98b33.svg";